const stripAccents = (value = '') =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const sanitizeDriverAccessSlug = (value = '', fallback = '') => {
  const source = String(value || fallback || '').trim();
  const normalized = stripAccents(source)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

  if (normalized) return normalized;

  const fallbackNormalized = stripAccents(String(fallback || 'chofer').trim())
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

  return fallbackNormalized || 'chofer';
};

export const buildDriverDisplayName = (source = {}, fallback = 'Sin chofer') => {
  const firstName =
    source?.firstName ||
    source?.driverName ||
    source?.currentDriverName ||
    source?.name ||
    '';
  const lastName =
    source?.lastName ||
    source?.driverLastName ||
    source?.currentDriverLastName ||
    '';

  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || String(firstName || '').trim() || fallback;
};

export const buildDriverSnapshot = (driver = {}, transport = {}) => ({
  driverId: driver?.id || transport?.currentDriverId || transport?.driverId || '',
  driverName: driver?.firstName || driver?.driverName || transport?.currentDriverName || transport?.driverName || '',
  driverLastName: driver?.lastName || driver?.driverLastName || transport?.currentDriverLastName || transport?.driverLastName || '',
  driverDni: driver?.dni || driver?.driverDni || transport?.currentDriverDni || transport?.driverDni || '',
  driverPhone: driver?.phone || driver?.driverPhone || transport?.currentDriverPhone || transport?.phone || '',
  driverPhotoURL: driver?.photoURL || driver?.driverPhotoURL || transport?.currentDriverPhotoURL || transport?.photoURL || '',
  driverAccessSlug:
    driver?.accessSlug ||
    driver?.driverAccessSlug ||
    transport?.driverAccessSlug ||
    transport?.slug || '',
});


export const buildTransportDisplayName = (source = {}, fallback = 'Unidad no registrada') => {
  const name = [
    source?.transportName,
    source?.transporterName,
    source?.name,
    source?.nameOfTransport,
    source?.transportLabel,
    source?.vehicleLabel,
    source?.transportModel,
    source?.patent,
    source?.transportType
  ]
    .map((value) => String(value || '').trim())
    .find(Boolean);

  return name || fallback;
};

export const buildTransportMeta = (source = {}) => {
  const displayName = buildTransportDisplayName(source, '');
  const parts = [
    source?.transportModel || source?.vehicleLabel || '',
    source?.transportType || '',
    source?.patent || source?.vehiclePatent || ''
  ]
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .filter((value, index, array) => array.indexOf(value) === index)
    .filter((value) => value.toLowerCase() !== displayName.toLowerCase());

  return parts.join(' · ');
};

export const buildOperationalAccessPath = (source = {}) => {
  const slug = String(
    source?.driverAccessSlug ||
    source?.accessSlug ||
    source?.slug ||
    ''
  ).trim();

  return slug ? `/empresa/transporter/${slug}` : '';
};

export const buildOperationalAccessUrl = (source = {}, origin = '') => {
  const path = buildOperationalAccessPath(source);
  const safeOrigin = String(origin || (typeof window !== 'undefined' ? window.location.origin : '')).trim();
  return path && safeOrigin ? `${safeOrigin}${path}` : path;
};
